/* eslint-disable import/prefer-default-export */

'use client';

import { ColumnDef } from '@tanstack/react-table';
import parse from 'html-react-parser';
import { IInvoiceProduct } from '../../../types/types';

export const columns: ColumnDef<IInvoiceProduct>[] = [
  {
    accessorKey: 'name',
    header: () => <div className="text-[9px] lg:text-sm">Product</div>,
    cell: ({ row }) => <div className="text-[9px] lg:text-sm">{row.getValue('name')}</div>,
  },
  {
    accessorKey: 'description',
    header: () => <div className="text-[9px] lg:text-sm">Description</div>,
    cell: ({ row }) => <div className="text-[9px] lg:text-sm">{parse(row.getValue('description'))}</div>,
  },
  {
    accessorKey: 'quantity',
    header: () => <div className="text-[9px] lg:text-sm">Quantity</div>,
    cell: ({ row }) => <div className="text-[9px] lg:text-sm">{row.getValue('quantity')}</div>,
  },
  {
    accessorKey: 'price',
    header: () => <div className="text-center text-[9px] lg:text-sm">Price(Rp)</div>,
    cell: ({ row }) => {
      const amount = parseFloat(row.getValue('price'));

      const formatted = new Intl.NumberFormat('id-ID').format(amount);

      return <div className="text-right font-medium text-[9px] lg:text-sm">{formatted}</div>;
    },
  },
  {
    accessorKey: 'discount',
    header: () => <div className="text-[9px] lg:text-sm">Discount</div>,
    cell: ({ row }) => <div className="text-[9px] lg:text-sm">{row.getValue('discount')}</div>,
  },
  {
    accessorKey: 'tax',
    header: () => <div className="text-[9px] lg:text-sm">Tax</div>,
    cell: ({ row }) => <div className="text-[9px] lg:text-sm">{row.getValue('tax')}</div>,
  },
  {
    accessorKey: 'amount',
    header: () => <div className="text-right text-[9px] lg:text-sm">Amount</div>,
    cell: ({ row }) => {
      const amount = parseFloat(row.getValue('amount'));

      const formatted = new Intl.NumberFormat('id-ID').format(amount);

      return <div className="text-right font-medium text-[9px] lg:text-sm">{formatted}</div>;
    },
  },
];
